import { Reveal } from "./Reveal";
import { PRESS, PRESS_QUOTE } from "../../data";

const MarqueeRow = () => (
  <div className="marquee-track">
    {[0, 1].map((dup) => (
      <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
        {PRESS.map((name) => (
          <span key={name} className="flex items-center">
            <span className="font-display font-bold text-4xl md:text-6xl text-navy/80 px-8 md:px-12 whitespace-nowrap">
              {name}
            </span>
            <span className="text-brand-orange text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </div>
    ))}
  </div>
);

export const Press = () => {
  return (
    <section
      id="press"
      data-testid="press-section"
      className="relative bg-warmgray py-24 md:py-32 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-orange mb-14 flex items-center gap-3">
            <span className="inline-block h-px w-10 bg-brand-orange" />
            As Seen In
          </p>
        </Reveal>
      </div>

      {/* Editorial marquee */}
      <div className="relative w-full py-4 border-y border-navy/10">
        <MarqueeRow />
      </div>

      <div className="mx-auto max-w-[1400px] px-5 md:px-10 mt-20 md:mt-28">
        <Reveal>
          <figure className="max-w-4xl">
            <span className="font-display font-black text-brand-orange text-7xl md:text-8xl leading-none block mb-2">
              &ldquo;
            </span>
            <blockquote
              data-testid="press-quote"
              className="font-display font-bold tracking-tight text-charcoal text-3xl md:text-5xl leading-[1.1] -mt-6"
            >
              {PRESS_QUOTE}
            </blockquote>
            <figcaption className="mt-8 font-mono text-sm uppercase tracking-widest text-charcoal/50">
              — Featured Press Coverage
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
};
